import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Calendar } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#2F1B10] text-white py-16 border-t border-[#8B4513]" data-id="element-69" data-mp="3ggtzeln15p6t">
      <div className="container mx-auto px-4 md:px-6" data-id="element-70" data-mp="32ovuyo49khgz">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-71" data-mp="36pft9v0kpr4p">
          <div data-id="element-72" data-mp="36pzebklisvmy">
            <h3 className="text-2xl font-bold mb-6 font-serif text-[#F4A460]" style={{
            fontFamily: 'Rockwell, "Courier New", serif'
          }} data-id="element-73" data-mp="36nd6rkymqg4q">
              Commerce CFO <br data-id="element-74" data-mp="3lem1u9lawtp9" />
              Roundtable - Austin
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-75" data-mp="3lggc8tyy53f3">
              Presented by ECOM CFO & ECOM CPA — an exclusive gathering of
              finance leaders from the ecommerce industry. Insights, networking,
              and authentic Texas BBQ.
            </p>
          </div>

          <div data-id="element-76" data-mp="2ezutxlxrg8lq">
            <h3 className="text-xl font-bold mb-6 text-[#FFF8DC]" data-id="element-77" data-mp="2ew716p053q82">
              Quick Links
            </h3>
            <ul className="space-y-3 text-gray-400" data-id="element-78" data-mp="3lbdbmpwng3k8">
              <li data-id="element-79" data-mp="3gbr0cm0dsxe2">
                <Link to="/" className="hover:text-[#D2691E] transition-colors flex items-center gap-2" data-id="element-80" data-mp="3gca859wbi5ed">
                  <span className="w-1.5 h-1.5 bg-[#D2691E] rounded-full" data-id="element-81" data-mp="3q8djn6d27gdz"></span>
                  Home
                </Link>
              </li>
              <li data-id="element-82" data-mp="817e07obdsul">
                <Link to="/sponsorship" className="hover:text-[#D2691E] transition-colors flex items-center gap-2" data-id="element-83" data-mp="80nvaoqub0fi">
                  <span className="w-1.5 h-1.5 bg-[#D2691E] rounded-full" data-id="element-84" data-mp="hsa8gqmqn9kw"></span>
                  Sponsorship
                </Link>
              </li>
              <li data-id="element-85" data-mp="qt049uc00zym">
                <a href="#register" className="hover:text-[#D2691E] transition-colors flex items-center gap-2" data-id="element-86" data-mp="qujmhqh7tl31">
                  <span className="w-1.5 h-1.5 bg-[#D2691E] rounded-full" data-id="element-87" data-mp="tv4j5q27khz7"></span>
                  Register
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-88" data-mp="ys3gehh6551m">
            <h3 className="text-xl font-bold mb-6 text-[#FFF8DC]" data-id="element-89" data-mp="13taokhn8468t">
              Event Details
            </h3>
            <ul className="space-y-4 text-gray-400" data-id="element-90" data-mp="18jr2s3yvbvw8">
              <li className="flex items-start gap-3" data-id="element-91" data-mp="18lbu7kpvyypv">
                <Calendar className="text-[#D2691E] mt-1" size={18} data-id="element-92" data-mp="1cm484r9pdrsh" />
                <span data-id="element-93" data-mp="1hkp60k1hfzdr">
                  October 12-13, 2026
                  <br data-id="element-94" data-mp="1hj49wpzis8ds" />
                  Two-Day Event
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-95" data-mp="1mkbj8thb9fmk">
                <MapPin className="text-[#D2691E] mt-1" size={18} data-id="element-96" data-mp="1rilef431cg86" />
                <span data-id="element-97" data-mp="1rgsh4febb8cu">
                  East Austin, Texas
                  <br data-id="element-98" data-mp="3oc6rez4cz201" />
                  Franklin Barbecue Dinner
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-99" data-mp="3tb1a812bsqk5">
                <Mail className="text-[#D2691E] mt-1" size={18} data-id="element-100" data-mp="2aevebtv95q6b" />
                <span data-id="element-101" data-mp="2agey3ug4ajcu">info@commercecfotable.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#8B4513] mt-16 pt-8 text-center text-gray-500 text-sm" data-id="element-102" data-mp="25mkdmosou0cp">
          <p data-id="element-103" data-mp="21kflxvlsvdsp">© 2026 Commerce CFO Roundtable. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}